export class ConstantItems {
  public portfolioUrl: string;
  public portfolioManagementUrl: string;
  public accountsUrl: string;
  public clientUrl: string;
  public clientCRMUrl: string;
  public clientRefreshUrl: string;
  public cModelUrl: string;
  public securityManagementUrl: string;
  public fileUrl: string;
  public healthUrl: string;
  public userUrl: string;
  public emailUrl: string;
  public reportingUrl: string;
  public reportsUrl: string;
  public tradingUrl: string;
  public portfolioManagementDashboardUrl: string;
  public feesUrl: string;
  public exchangeUrl: string;
  public complianceUrl: string;
}

export class Constants {
  private static getApiUrl() {
    let url = `${location.protocol}//api.${location.host}`;
    if (location.hostname == "localhost" || location.hostname == "10.0.75.1") {
      url = "http://localhost:8080";
      //url = "https://api.uat.confidentportal.com";
    } else if (location.origin.includes("dev")) {
      url = "https://api.dev.confidentportal.com";
    } else if (location.origin.includes("uat")) {
      url = "https://api.uat.confidentportal.com";
    } else {
      url = "https://api.confidentportal.com";
    }
    // url="https://api.dev.confidentportal.com"
    return url;
  }

  static get Default(): ConstantItems {
    let url = this.getApiUrl();
    let item = new ConstantItems();
    item.portfolioUrl = url + "/portfolios";
    item.portfolioManagementUrl = url + "/portfolios/management";
    item.portfolioManagementDashboardUrl = url + "/portfolios/dashboard";
    item.clientUrl = url + "/clients";
    item.clientCRMUrl = url + "/clients/crm";
    item.accountsUrl = item.clientUrl + "/accounts";
    item.clientRefreshUrl = item.clientUrl + "/refresh";
    item.cModelUrl = url + "/cmodels";
    item.securityManagementUrl = item.cModelUrl + "/securities";
    item.fileUrl = url + "/files";
    item.healthUrl = url + "/health";
    item.userUrl = url + "/users";
    item.reportingUrl = url + "/reporting";
    item.reportsUrl = url + "/reports";
    item.tradingUrl = url + "/trading";
    item.emailUrl = url + "/users";
    item.feesUrl = url + "/fees";
    item.exchangeUrl = url + "/exchangerate";
    item.complianceUrl = url + "/compliance";
    return item;
  }

  static PROD = "Production";
  static STAGE = "Staging";
  static DEV = "Development";

  static getEnvironment() {
    if (location.hostname == "localhost") {
      return "Local";
    }
    return location.hostname.split(".")[0] === "dev"
      ? Constants.DEV
      : location.hostname.split(".")[0] === "uat"
      ? Constants.STAGE
      : Constants.PROD;
  }

  static getBucketEnvironment() {
    if (location.hostname == "localhost") {
      return "Local";
    }
    return location.hostname.includes("dev")
      ? Constants.DEV
      : location.hostname.includes("uat")
      ? Constants.STAGE
      : Constants.PROD;
  }

  static getDocumentBucket() {
    var environment = this.getEnvironment();
    var bucketName = "arkanoid-client-onboarding-documents";
    if (environment === Constants.DEV) {
      return "uat-" + bucketName;
    } else if (environment === Constants.STAGE) {
      return "uat-" + bucketName;
    } else if (environment === "Local") {
      return "uat-" + bucketName;
    } else {
      return bucketName;
    }
  }

  static getMobileWebsite() {
    var environment = this.getEnvironment();
    var domain = "confidentportal.com/";
    var urlIntro = "https://www.mobile.";
    //"https://www.mobile.uat.confidentportal.com/";
    if (environment === Constants.DEV) {
      return urlIntro + "uat." + domain;
    } else if (environment === Constants.STAGE) {
      return urlIntro + "uat." + domain;
    } else if (environment === "Local") {
      return urlIntro + "uat." + domain;
    } else {
      return urlIntro + domain;
    }
  }

  static getBucket(provider) {
    var environment = this.getBucketEnvironment();
    if (provider === "MCB") {
      if (environment === Constants.DEV) {
        return "uat-mcb-sftp";
      } else if (environment === Constants.STAGE) {
        return "uat-mcb-sftp";
      } else if (environment === "Local") {
        return "uat-mcb-sftp";
      } else {
        return "mcb-sftp";
      }
    } else if (provider === "EDR") {
      if (environment === Constants.DEV) {
        return "uat-edr-sftp";
      } else if (environment === Constants.STAGE) {
        return "uat-edr-sftp";
      } else if (environment === "Local") {
        return "uat-edr-sftp";
      } else {
        return "edr-sftp";
      }
    } else {
      if (environment === Constants.DEV) {
        return "uat-generic-sftp";
      } else if (environment === Constants.STAGE) {
        return "uat-generic-sftp";
      } else if (environment === "Local") {
        return "uat-generic-sftp";
      } else {
        return "generic-sftp";
      }
    }
  }
}

export const getDefaultConfig = (): ng.IRequestShortcutConfig => {
  var requestHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("id_token")}`,
  };
  var requestOptions = {
    headers: requestHeaders,
  };
  return requestOptions;
};

export const getIncreasedTimeoutConfig = (): ng.IRequestShortcutConfig => {
  var requestHeaders = {
    Accept: "application/json",
    "Content-Type": "application/json",
    Authorization: `Bearer ${localStorage.getItem("id_token")}`,
    proxy_read_timeout: "5m",
    proxy_connect_timeout: "5m",
    proxy_send_timeout: "5m",
  };
  var requestOptions = {
    headers: requestHeaders,
  };
  return requestOptions;
};



// WEBPACK FOOTER //
// ./src/constants/shared.ts